import { graphql } from "@/graphql/codegen"

graphql(`
  mutation ApprovePayFile($input: PayFileApproveInput!) {
    payFile {
      approve(input: $input) {
        __typename
        ... on PayFileApproveSuccess {
          payFile {
            payFileId
          }
        }
        ... on PayFileApproveFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
